/** Full action labels (for timeline badges / global log). */
export const USER_AUDIT_ACTION_OPTIONS = [
  { value: "USER_CREATED", label: "User created" },
  { value: "USER_SIGNUP_COMPLETED", label: "Signup completed" },
  { value: "USER_UPDATED", label: "User updated" },
  { value: "ROLE_CHANGED", label: "Role changed" },
  { value: "USER_DISABLED", label: "User disabled" },
  { value: "USER_ENABLED", label: "User enabled" },
  { value: "USER_DELETED", label: "User deleted" },
  { value: "USER_REACTIVATED", label: "User reactivated" },
  { value: "PASSWORD_CHANGED", label: "Password changed" },
  { value: "PASSWORD_RESET_REQUESTED", label: "Password reset requested" },
  { value: "PASSWORD_RESET_COMPLETED", label: "Password reset completed" },
  { value: "PASSWORD_RESET_BY_ADMIN", label: "Password reset by admin" },
  { value: "MFA_RESET", label: "MFA reset" },
  { value: "MFA_EXEMPTION_GRANTED", label: "MFA exemption granted" },
  { value: "MFA_EXEMPTION_REMOVED", label: "MFA exemption removed" },
  { value: "TRUSTED_DEVICES_REMOVED", label: "Trusted devices removed" },
  { value: "ACCOUNT_LOCKED", label: "Account locked" },
  { value: "ACCOUNT_UNLOCKED", label: "Account unlocked" },
  { value: "AUDIT_TRAIL_VIEWED", label: "Audit trail viewed" },
  { value: "AUDIT_TRAIL_EXPORTED", label: "Audit trail exported" },
  { value: "AUDIT_CHAIN_VERIFIED", label: "Audit chain verified" },
];

/** Action filter options for User History modal only. */
export const USER_HISTORY_ACTION_OPTIONS = [
  { value: "USER_CREATED", label: "User created" },
  { value: "USER_SIGNUP_COMPLETED", label: "Signup completed" },
  { value: "USER_UPDATED", label: "User updated" },
  { value: "ROLE_CHANGED", label: "Role changed" },
  { value: "USER_DISABLED", label: "User disabled" },
  { value: "USER_ENABLED", label: "User enabled" },
  { value: "USER_DELETED", label: "User deleted" },
  { value: "USER_REACTIVATED", label: "User reactivated" },
  { value: "PASSWORD_CHANGED", label: "Password changed" },
  { value: "PASSWORD_RESET_REQUESTED", label: "Password reset requested" },
  { value: "PASSWORD_RESET_COMPLETED", label: "Password reset completed" },
  { value: "ACCOUNT_LOCKED", label: "Account locked" },
  { value: "ACCOUNT_UNLOCKED", label: "Account unlocked" },
  { value: "AUDIT_TRAIL_VIEWED", label: "Audit trail viewed" },
  { value: "AUDIT_TRAIL_EXPORTED", label: "Audit trail exported" },
];

export const USER_AUDIT_STATUS_OPTIONS = [
  { value: "SUCCESS", label: "Success" },
  { value: "FAILED", label: "Failed" },
  { value: "DENIED", label: "Denied" },
];

export const USER_AUDIT_TARGET_ROLE_OPTIONS = [
  { value: "admin", label: "Administrator" },
  { value: "manager", label: "Manager" },
  { value: "reviewer", label: "Reviewer" },
  { value: "viewer", label: "Viewer" },
  { value: "company_admin", label: "Company admin" },
  { value: "employee", label: "Employee" },
];

export const actionLabel = (code) =>
  USER_AUDIT_ACTION_OPTIONS.find((o) => o.value === code)?.label || code || "—";

export const statusClass = (status) => {
  const s = String(status || "").toUpperCase();
  if (s === "SUCCESS") return "status-approved";
  if (s === "FAILED") return "status-rejected";
  if (s === "DENIED") return "status-pending";
  return "";
};
